// Exposed as `posthog-js/rrweb` via packages/browser/rrweb/package.json.
export * from '@posthog/rrweb'
